import { Reducer } from 'redux'
import { AzureChangeType, AzureFormActions, mapAzureApiToForm } from './actions'
import {
  PartialAzureFormObject,
  ReferralAzureForm,
  ReferralAzureFormSections,
} from './types'

import {
  AzureTeamMember,
  AzureReferralSolution,
} from '../../../api/CoSell/index'

export interface ReferralForm {
  referralForm: ReferralAzureFormSections
  referral?: Partial<ReferralAzureForm>
  formChanged: boolean
  errorsFromBackend?: Partial<Record<keyof ReferralAzureForm, string>>
  teamMembers?: AzureTeamMember[]
  solutions?: AzureReferralSolution[]
  status?: string
  substatus?: string
}
export const initialState: ReferralForm = {
  referralForm: {
    customerDetails: {
      customerName: '',
      website: '',
      city: '',
      state: '',
      country: '',
      postalCode: '',
      firstName: '',
      lastName: '',
      fullName: '',
      email: '',
      phone: '',
      address: '',
    },
    dealDetails: {
      dealType: '',
      dealName: '',
      location: '',
      currency: '',
      estimatedValue: 0,
      estimatedCloseDate: '',
      crmId: '',
      marketingCampaignID: '',
      solutionArea: '',
      solutionPlay: '',
      customerPurchaseIntent: '',
      teamMembers: [],
      partnerNotes: '',
    },
    solutionsOffered: {
      solutionsOffered: [],
    },
    helpFromMicrosoft: {
      typeOfHelp: '',
      sellerDealView: undefined,
      notesToMicrosoft: '',
    },
  },
  formChanged: false,
  teamMembers: [],
  solutions: [],
  status: undefined,
  substatus: undefined,
}

type actionType =
  | {
      type: AzureFormActions.SET_AZURE_FORM
      payload: ReferralAzureFormSections
    }
  | {
      type: AzureFormActions.UPDATE_AZURE_FORM
      payload: AzureChangeType
    }
  | {
      type: AzureFormActions.SET_AZURE
      payload: PartialAzureFormObject
    }
  | {
      type: AzureFormActions.SET_FORM_AZURE_ERRORS
      payload: Partial<Record<keyof ReferralAzureForm, string>>
    }
  | {
      type: AzureFormActions.CLEAR_AZURE_FORM
    }
  | {
      type: AzureFormActions.SET_AZURE_TEAM_MEMBERS
      payload: AzureTeamMember[]
    }
  | {
      type: AzureFormActions.SET_AZURE_SOLUTIONS
      payload: AzureReferralSolution[]
    }
  | {
      type: AzureFormActions.SET_AZURE_STATUS
      payload: { status: string; substatus: string }
    }

export const reducer: Reducer<ReferralForm, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case AzureFormActions.SET_AZURE_FORM: {
      return {
        ...state,
        referralForm: action.payload,
      }
    }
    case AzureFormActions.UPDATE_AZURE_FORM: {
      const { sectionName, data } = action.payload
      return {
        ...state,
        referralForm: {
          ...state.referralForm,
          [sectionName]: {
            ...state.referralForm[sectionName],
            ...data,
          },
        },
      }
    }
    case AzureFormActions.SET_AZURE: {
      // Convert from API format to form format
      const referralsObject = action.payload.referralObjectTransformed
        ? action.payload.referralObjectTransformed
        : mapAzureApiToForm(action.payload.referralObject || {})
      return {
        ...state,
        referral: {
          ...state.referral,
          ...action.payload,
          referralObjectTransformed: referralsObject,
        },
      }
    }
    case AzureFormActions.SET_FORM_AZURE_ERRORS: {
      return {
        ...state,
        errorsFromBackend: {
          ...action.payload,
        },
      }
    }
    case AzureFormActions.CLEAR_AZURE_FORM: {
      return (state = initialState)
    }
    case AzureFormActions.SET_AZURE_TEAM_MEMBERS: {
      return {
        ...state,
        teamMembers: action.payload,
      }
    }
    case AzureFormActions.SET_AZURE_SOLUTIONS: {
      return {
        ...state,
        solutions: action.payload,
      }
    }
    case AzureFormActions.SET_AZURE_STATUS: {
      return {
        ...state,
        status: action.payload.status,
        substatus: action.payload.substatus,
      }
    }

    default: {
      return state
    }
  }
}
